import { isNil } from "lodash-es";
import type { Context } from "solid-js";
import { useContext } from "solid-js";

export const initialized = <T>(dependency: T | undefined | null, name: string) => {
  if (isNil(dependency)) {
    throw new Error(`${name} is not initialized`);
  }
  return dependency;
};

export const initializedContext = <T>(context: Context<T | undefined>, name: string, providerName: string) => {
  const value = useContext(context);

  if (isNil(value)) {
    throw new Error(`${name} must be used within a ${providerName}`);
  }
  return value;
};
